// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ed237bac","453":"8d8e1995","732":"cfe67d3e"}[chunkId] + ".chunk.js";
};